import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-bank-id-button',
  templateUrl: './bank-id-button.component.html',
  styleUrls: ['./bank-id-button.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class BankIdButtonComponent {
  @Input() disabled = false;
  @Output() bankIdClick = new EventEmitter<void>();

  onBankIdClick(event: MouseEvent): void {
    event.preventDefault();
    this.bankIdClick.emit();
  }
}
